






import { Component, Prop, Vue, Watch } from 'saiten-base';
import { ConstsState, Modal, SaitenApi, DmShareds } from "saiten-base";

// CombineUploader, http, DmModal, dm_service
@Component({components: {Modal, "combine-uploader": DmShareds.CombineUploader}, mixins:[]})
export default class UploadDialog extends Vue {
  get dialog() {return this.$refs.my_dialog as any}
  sheet_activity: any = {};
  get page_count(): number {
    if(this.sheet_activity.camera_image_ids) return this.sheet_activity.camera_image_ids.length;
    return 0;
  }

  mounted(){
  }
  show(sheet_activity: any){
    this.sheet_activity = sheet_activity;
    this.dialog.show();
  }
  answer_success(res: any) {
    // 回答成功
    alert("登録が完了しました");
    this.dialog.hide();
    this.$emit('load');
  }
  answer_error(e: any) {
    // 回答エラー
    alert("保存エラー");
  }
}
